import '@/styles/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/app';

/**
 * 목 모드(pnpm dev:mock)면 MSW 서비스 워커가 API 를 가로챈 뒤에 화면을 띄운다.
 * import.meta.env 를 직접 비교해야 빌드 때 값이 박혀서, 목 모드가 아닌 번들에서는 MSW 코드가 통째로 빠진다.
 */
async function enableMocking(): Promise<void> {
  if (import.meta.env.VITE_API_MOCKING !== 'true') return;
  const { worker } = await import('@/mocks/browser');
  await worker.start({ onUnhandledFrame: 'bypass', quiet: true });
}

const container = document.getElementById('root');
if (!container) throw new Error('#root 가 없어요');

void enableMocking().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
